export class InvalidHealthCardError extends Error {
  constructor() {
    super('Carteirinha de convênio inválida')
    this.name = 'InvalidHealthCardError'
  }
}
